import { useState } from 'react'

import { Flex } from '@/components/ui/flex'
import { getMyLearningTotals } from '@/store/tasksApprovals/utils'
import { TCompliancesData, TCompliancesDataAsObject } from '@/types/tasksApprovals'

import LeftSide from './leftSide'
import RightSide from './rightSide'

const Container = ({
    iconColor,
    isSelected,
    textColor,
    directsCompliances,
    myCompliances,
}: {
    iconColor: string
    isSelected: boolean
    textColor: string
    myCompliances: TCompliancesData
    directsCompliances: TCompliancesData
}) => {
    const [totals] = useState<TCompliancesDataAsObject>({
        MANDATORY: getMyLearningTotals('MANDATORY', directsCompliances, myCompliances),
        REQUIRED: getMyLearningTotals('REQUIRED', directsCompliances, myCompliances),
        OPTIONAL: getMyLearningTotals('OPTIONAL', directsCompliances, myCompliances),
    })
    return (
        <Flex justifyContent="space-between">
            <LeftSide iconColor={iconColor} textColor={textColor} totals={totals} />
            <RightSide
                directsCompliances={directsCompliances}
                myCompliances={myCompliances}
                iconColor={iconColor}
                textColor={textColor}
                totals={totals}
                isSelected={isSelected}
            />
        </Flex>
    )
}

export default Container
